export default __webpack_public_path__ + "static/media/warningred.21abcb93.svg";